import ContentCard from '@/components/ContentCard';
import EmptySection from '@/components/EmptySection';
import Constants from '@/Constants';
import { Lesson } from '@/models/Lesson';
import { ApplicationState } from '@/store';
import { closeModal } from '@/store/common/actions';
import { deleteContentFromCourseRequest, reorderContentListRequest, setAddedContentList } from '@/store/student/actions';
import React, { useEffect, useState } from 'react';
import { DragDropContext, Draggable, DraggableProvided, Droppable, DroppableProvided, DropResult } from 'react-beautiful-dnd';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import './style.scss';

const AddedContent: React.FC = () => {
    const dispatch = useDispatch();

    const { strings, personId, myCurrentCourse, addedLessons, courseStudentView } = useSelector((state: ApplicationState) => {
        return {
            personId: state.identity.data.person.id || 0,
            myCurrentCourse: state.lists.courseData,
            strings: state.locale.data,
            addedLessons: state.student.myListData.courseStudentView.course.lessons || [],
            courseStudentView: state.student.myListData.courseStudentView,
        };
    });

    const [numberOfLessons, setNumberOfLessons] = useState<number>(addedLessons.length);
    const history = useHistory();

    const isEditing = Number(localStorage.getItem('myCourseInEdition')) === myCurrentCourse.id;

    const onConcludeHandler = () => {
        dispatch(closeModal(Constants.modal.MORE_OPTIONS));
        if (isEditing) {
            history.goBack();
        }
        history.replace(`/courses/${myCurrentCourse.id}`);
    };

    const removeContent = (contentId: number): void => {
        dispatch(deleteContentFromCourseRequest(contentId, personId, myCurrentCourse.id));
    };

    const getAddedLessonsTitle = () => (numberOfLessons === 1 ? strings.ADDED_ITEM : strings.ADDED_ITEMS);

    const onDragEnd = (result: DropResult): void => {
        const { source, destination } = result;
        if (destination && source.droppableId === destination.droppableId) {
            const result = [...addedLessons];
            const [movedLesson]: Lesson[] = result.splice(source.index, 1);
            const lessonOrder = result[destination.index] ? result[destination.index].lessonOrder : result.length;
            dispatch(reorderContentListRequest(movedLesson.id, lessonOrder));
            result.splice(destination.index, 0, movedLesson);
            dispatch(
                setAddedContentList(
                    result.map((e, index) => {
                        e.lessonOrder = index;
                        return e;
                    }),
                ),
            );
        }
    };

    useEffect(() => setNumberOfLessons(addedLessons.length), [addedLessons.length]);

    return (
        <div className="added-contents">
            {addedLessons.length === 0 ? (
                <EmptySection iconName={Constants.icons.SMS_FAILED} message={strings.SUGGESTED_CONTENTS.NO_CONTENTS_ADDED} outlined={false} />
            ) : (
                <>
                    <h3 className="added-contents-title">
                        <b>{numberOfLessons < 10 ? `0${numberOfLessons}` : numberOfLessons}</b> {getAddedLessonsTitle()}
                    </h3>
                    <DragDropContext onDragEnd={onDragEnd}>
                        <Droppable droppableId="droppable">
                            {(provided: DroppableProvided) => (
                                <div ref={provided.innerRef} {...provided.droppableProps} className="draggable-list">
                                    {addedLessons.map((lesson: Lesson, index) => {
                                        return (
                                            <Draggable draggableId={`${lesson.id}`} index={index} key={lesson.id}>
                                                {(providedDraggable: DraggableProvided) => (
                                                    <div
                                                        ref={providedDraggable.innerRef}
                                                        {...providedDraggable.draggableProps}
                                                        {...providedDraggable.dragHandleProps}
                                                        className="draggable-list-item"
                                                    >
                                                        <i className="material-icons-outlined drag-indicator-icon">
                                                            {Constants.icons.DRAG_INDICATOR}
                                                        </i>

                                                        <ContentCard
                                                            content={lesson.content}
                                                            editionConfig={{
                                                                title: strings.REMOVE,
                                                                handle: () => removeContent(lesson.id || 0),
                                                                hasVisibilityDate: !!courseStudentView.course.visibilityDate,
                                                            }}
                                                            editionMode
                                                            finished={false}
                                                            key={lesson.id}
                                                        />
                                                    </div>
                                                )}
                                            </Draggable>
                                        );
                                    })}
                                </div>
                            )}
                        </Droppable>
                    </DragDropContext>
                    <div className="conclude">
                        <div className="conclude-container">
                            <div className="conclude-container-gradient">
                                <button className="btn btn-primary btn-conclude" onClick={onConcludeHandler}>
                                    {strings.CONCLUDE}
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default AddedContent;
